enum RoleName {
  AnalyticsAdministrator = 'Analytics administrator',
  BaseAnalytics = 'Base analytics',
  BenchmarkingLite = 'Benchmarking Lite',
  BenchmarkingLiteAdmin = 'Benchmarking Lite admin',
  BenchmarkingPlus = 'Benchmarking Plus',
  BenchmarkingPlusAdmin = 'Benchmarking Plus admin',
  Boarder = 'Boarder',
  BoopUser = 'Boop user',
  CWAV = 'CWAV',
  ChewyAuthorization = 'Chewy Authorization',
  Client = 'Client',
  ClientConcierge = 'Client Concierge',
  CoPetParent = 'Co-pet parent',
  Finance = 'Finance',
  FinanceAndBI = 'Finance and BI',
  Groomer = 'Groomer',
  GroupAnalytics = 'Group analytics',
  GroupAnalyticsAdmin = 'Group Analytics Admin',
  HospitalManager = 'Hospital Manager 1',
  HospitalManager2 = 'Hospital Manager 2',
  ImportAdministrator = 'Import administrator',
  InventoryManagement = 'Inventory management',
  Marketing = 'Marketing',
  Marketing2 = 'Marketing 2',
  MarketingAnalytics = 'Marketing analytics',
  MarketingAnalyticsAdmin = 'Marketing Analytics Admin',
  OfficeStaff = 'Office staff',
  PetParent = 'Pet parent',
  PetabyteAdministrator = 'Petabyte administrator',
  PetabyteAnalytics = 'Petabyte analytics',
  PetabyteAnalyticsAdmin = 'Petabyte Analytics Admin',
  PracticeAdministrator = 'Practice administrator',
  ReportBuilder = 'Report builder',
  ReportBuilderAdmin = 'Report Builder Admin',
  SuperAdmin = 'Super admin',
  VCR = 'Veterinary Care Representative',
  VetAssistant = 'Vet assistant',
  VetTech = 'Vet tech',
  Veterinarian = 'Veterinarian',
  Veterinarian2 = 'Veterinarian 2',
  Walker = 'Walker',
}

export default RoleName
